function wrapTables(root) {
  root.querySelectorAll('.prose table, .shopify-section--main-page table, .accordion__content table').forEach(function(table) {
    if (table.closest('.table-scroller')) return;
    var wrap = document.createElement('div');
    wrap.className = 'table-scroller';
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });
}

document.addEventListener('DOMContentLoaded', function() {
    wrapTables(document);
    document.addEventListener('click', function(event) {
      const target = event.target;
      if (target.matches('[name="checkout"], [name="goto_pp"], [name="goto_gc"]')) {
        const agreeCheckbox = document.getElementById('agree');
        if (agreeCheckbox.checked) {
          event.target.form.submit();
        } else {
          alert(Shopify.translations.cartAcceptTerms);
          event.preventDefault();
        }
      }
    });
});